import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Flame, X } from "lucide-react";
import { useLang } from "../context/LanguageContext";
import api from "../lib/api";

const T = {
  el: { cta: "Δες τα μαθήματα", today: "Προσφορά ημέρας", ends: "λήγει σε", h: "ώρ", m: "λ", close: "Κλείσιμο" },
  en: { cta: "Browse courses", today: "Today's offer", ends: "ends in", h: "h", m: "m", close: "Close" },
};

export const OfferBanner = () => {
  const { lang } = useLang();
  const tr = T[lang] || T.el;
  const [offer, setOffer] = useState(null);
  const [left, setLeft] = useState(0);

  useEffect(() => {
    api.get("/offers/today").then(({ data }) => {
      if (data?.active && localStorage.getItem(`ssa_offer_hidden_${data.ends_at}`) !== "1") setOffer(data);
    }).catch(() => {});
  }, []);

  useEffect(() => {
    if (!offer?.ends_at) return undefined;
    const tick = () => setLeft(new Date(offer.ends_at).getTime() - Date.now());
    tick();
    const id = setInterval(tick, 30000);
    return () => clearInterval(id);
  }, [offer]);

  if (!offer || left <= 0) return null;

  const s = Math.max(0, Math.floor(left / 1000));
  const timer = `${tr.ends} ${Math.floor(s / 3600)}${tr.h} ${Math.floor((s % 3600) / 60)}${tr.m}`;

  const dismiss = () => {
    localStorage.setItem(`ssa_offer_hidden_${offer.ends_at}`, "1");
    setOffer(null);
  };

  return (
    <div className="bg-[#0B1B3A] text-white" data-testid="offer-banner">
      <div className="max-w-7xl mx-auto px-5 sm:px-6 py-2.5 flex items-center gap-3 text-xs sm:text-sm">
        <Flame className="w-4 h-4 text-[#60A5FA] shrink-0" />
        <p className="font-semibold truncate flex-1 min-w-0">
          {tr.today}: {lang === "en" ? offer.label_en : offer.label} · −{offer.discount}%
          <span className="text-[#93C5FD] font-normal ml-2 hidden sm:inline">· {timer}</span>
        </p>
        <Link data-testid="offer-banner-cta" to="/courses"
          className="shrink-0 font-bold underline decoration-[#60A5FA] decoration-2 underline-offset-4 hover:text-[#93C5FD] transition-colors duration-200">
          {tr.cta}
        </Link>
        <button data-testid="offer-banner-close" aria-label={tr.close} onClick={dismiss}
          className="shrink-0 p-1 rounded-full text-[#93C5FD] hover:text-white hover:bg-white/10 transition-colors duration-200">
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};

export default OfferBanner;
